import axios from 'axios';
import { API_URL } from '@/config';

export default {
  list() {
    return axios.get(`${API_URL}/snapshots`);
  },
};
